// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gU8dj","buttons":"styles_buttons__1YAgf"};